import { render, staticRenderFns } from "./paymentStatus.vue?vue&type=template&id=95a43374"
import script from "./paymentStatus.vue?vue&type=script&lang=js"
export * from "./paymentStatus.vue?vue&type=script&lang=js"
import style0 from "./paymentStatus.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports